import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { useGetInteractionContext } from '#src/hooks/useGetInteractionContext.ts';

import type {
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables,
} from './__generated__/useSubscribe.graphql.ts';

const CREATE_SUBSCRIPTION_MUTATION = gql`
  mutation CreateSubscriptionMutation($input: createSubscriptionInput!) {
    createSubscription(input: $input) {
      subscription {
        id
        slug
        anySubscribable {
          slug
          currentUserSubscription {
            slug
          }
          subscriptionsCount
          ... on User {
            slug
            followed {
              slug
            }
          }
        }
        preferences {
          slug
          notifyForRarities
        }
      }
    }
  }
` as TypedDocumentNode<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;

export const useSubscribe = (refetchQueries?: string[]) => {
  const [subscribe] = useMutation(CREATE_SUBSCRIPTION_MUTATION);
  const interactionContext = useGetInteractionContext()();

  return async (subscribable: { __typename: string; slug: string }) => {
    return subscribe({
      variables: {
        input: {
          subscribable: {
            type: subscribable.__typename,
            slug: subscribable.slug,
          },
          interactionContext,
        },
      },
      refetchQueries,
    });
  };
};
